import { Component, OnInit, EventEmitter } from '@angular/core';
import { Utils } from '../../util';
import { CustomerBillId, CustomerBillService } from '../../services/customer-bill.service';
import { IncomeId, IncomeService, IncomeData } from '../../services/income.service';
import { Table, Cells, Globals, Ref } from '../../globals';
import { EmployeeId } from '../../services/employee.service';
import { toast, MaterializeAction } from 'angular2-materialize';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

interface Bill extends CustomerBillId{ readonly amount: number };
interface Doc { readonly amount: number, readonly employeeRef: Ref, readonly date: string, readonly folio: string }

@Component({
  selector: 'app-yearly-report',
  templateUrl: './yearly-report.component.html',
  styleUrls: ['./yearly-report.component.css']
})
export class YearlyReportComponent implements OnInit {
  permission: Partial<{[K in keyof typeof SpecialPermissions]: boolean}> = {};
  loading: boolean[] = Array(2).fill(false);
  get loaded(): boolean { return !this.loading.includes(false); }

  filter = {
    year: Utils.now.year,
    appliesIva: true,
    doc: false,
  }
  years: string[] = [...Array(90)].map((u, i) => `20${10 + i}`);

  docs: {
    bills?: Bill[],
    incomes?: IncomeId[],
    employees?: {[s: string]: EmployeeId},
  } = { employees: {}};

  table: Table;
  rows: {[s: string]: {docs: Doc[], sums: number[]}};

  get Utils(){ return Utils };
  constructor(
    private service: CustomerBillService,
    private incomeService: IncomeService,
    private incomeData: IncomeData,
    private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser.email).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
      if(!this.permission || !this.permission.yearlyReport){
        toast('No tiene permisos.', 3000);
        this.router.navigate(['/']);
      }
      else{
        let {yearlyRepFilter: filter = ''} = localStorage;
        if(filter) this.filter = JSON.parse(filter);
        this.getDocs();
      }
    });
    
  }

  ngOnInit() {}

  getDocs(){
    let filter = this.filter;
    let {year} = filter;
    this.loading = Array(2).fill(false);
    this.docs = {bills: [], incomes: [], employees: {}}
    let sub0 = this.service.getCustomerBills({year, onEmpty: () => { this.loading[0] = true; this.processDocs(); }}).subscribe(bills => {
      sub0.unsubscribe();
      this.loading[0] = true;
      this.docs.bills = bills.map(({totals: t, employeeObj: emp, ...bill}) => {
        if(emp) this.docs.employees[emp.id] = {...emp};
        return <Bill>{ get amount(){ return filter.appliesIva ? t.total : t.subtotal }, totals: t, employeeObj: emp, ...bill }
      });
      this.processDocs();
    });
    let sub1 = this.incomeService.getIncomes({year, onEmpty: () => { this.loading[1] = true; this.processDocs(); }}).subscribe(incomes => {
      sub1.unsubscribe();
      this.loading[1] = true;
      this.docs.incomes = incomes.map(({employeeObj: emp, payMethod='999', ...income}) => {
        if(emp) this.docs.employees[emp.id] = {...emp};
        return <IncomeId>{ employeeObj: emp, payMethod: this.incomeData.statusObjects[payMethod], ...income };
      });
      this.processDocs();
    });
  }
  processDocs(){
    if(!this.loaded) return;
    localStorage.yearlyRepFilter = JSON.stringify(this.filter);
    console.log(this.docs);
    
    const PRESUPUESTO = 0;
    let {bills, incomes, employees: es} = this.docs;
    let employees = Object.values(es);
    let docs: {[s: string]: Doc[]} = employees.reduce((acc, cur) => ({...acc, [cur.id]: [...(this.filter.doc ? incomes: bills)].filter(({employeeRef: {id=''}={}}) => cur.id == id) }), {});
    this.rows = Globals.MONTHS.reduce((acc, cur, i) => ({
      ...acc,
      [cur]: {
        docs: Utils.sort(employees.reduce((a, c) => [...a, ...docs[c.id].filter(({date: d}) => +d.split('-')[1] == i+1)], []), [{key: 'folio'}]),
        sums: employees.map(({id}) => docs[id].reduce((acc,{amount:a, date:d}) => acc + (+d.split('-')[1] == i+1 ? a : 0), 0) )
      }
    }), {})
    this.table = {
      caption: 'Reporte Acumulado',
      columns1: Cells(['Mes', ...employees.map(({name, lastName}) => `${name} ${Utils.initials(lastName)}` ), 'Suma', 'Presupuesto', 'Estatus', 'Info']),
      rows1: Globals.MONTHS.map(month => [
        month,
        ...this.rows[month].sums.map(n => Utils.money(n)),
        ...this.rows[month].sums.reduce(([s,p,e], cur) => [s + cur, p, p - cur], [0,PRESUPUESTO,0]).map(n => Utils.money(n)),
      ])
    }
    let [row1, ...rows] = this.table.rows1;
    this.table.rows2 = [rows.reduce(([m, ...r]: string[], [x, ...r2]: string[]) => ['Suma', ...Utils.arraySum(r, r2, {money: true})], row1)];
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////Show
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  currentMonth: string;

  openModalShow(month: string){
    this.currentMonth = month;
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////Show


}
